import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseMenuService, MenuItem } from '@fry/lib/menu';
import { AuthService } from '@fry/lib/auth'; // Adjust paths as needed
import { SecurityService } from '@fry/lib/security';
import { SYSTEM_ROLE_ID } from "@fry/lib/roles/roles.system";

@Injectable({
  providedIn: 'root'
})
export class ConnectionsMenu extends BaseMenuService {

  private static readonly connectionsRoutes: MenuItem[] = [
    {
      id: 'connections',
      link: '/settings/connections',
      title: $localize`Connections`,
      parent: 'settings'
    }
  ];

  constructor(auth: AuthService, security: SecurityService) {
    super(auth, security);
  }

  public cook(): Observable<MenuItem[]> {
    return this.mergeItems(
      of([
        {
          id: 'settings',
          title: $localize`Settings`
        }
      ]),
      this.menuWithRole(ConnectionsMenu.connectionsRoutes, SYSTEM_ROLE_ID.SUPER_ADMIN),
    );
  }
}
